import { render, staticRenderFns } from "./paramsPage.vue?vue&type=template&id=e7c5fc9a&scoped=true"
import script from "./paramsPage.vue?vue&type=script&lang=js"
export * from "./paramsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7c5fc9a",
  null
  
)

export default component.exports